import { useQuery } from 'react-query';
import { CATALOG_INVENTORY_TAB_COUNTS_QUERY_KEY } from '../../constants/query';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import CatalogInventoryService from '../../services/catalog-inventory.service';

const useGetCatalogInventoryTabCounts = ({ catalogInventoryId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery(
    [CATALOG_INVENTORY_TAB_COUNTS_QUERY_KEY, catalogInventoryId, customerEnvId],
    () => CatalogInventoryService.getCatalogInventoryTabCounts({ catalogInventoryId, customerEnvId }),
    { enabled: !!customerEnvId && !!catalogInventoryId }
  );
};

export default useGetCatalogInventoryTabCounts;
